import styled from 'styled-components';

export const StrategicSectionWrapper = styled.div`
  padding: 64px 0;

  [class*='SimpleGridstyle__SimpleGrid-sc'] {
    justify-content: space-around
  }
`;

export const StrategicSectionHeader = styled.h3`
  font-family: 'Vodafone';
  font-size: 40px;
  font-weight: 700;
  line-height: 48px;
  text-align: center;

  @media only screen and (max-width: 767px) {
    font-size: 28px;
    line-height: 36px;
  }
`;
